import React from "react";
import { Link } from "react-router-dom";
import { Facebook, MapPin, Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-16 border-t border-border bg-[#2D1E18] text-[#F7F3EE]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo-hero.png" alt="LVLDC logo" className="h-16 w-auto" />
            <div>
              <p className="font-display text-lg font-extrabold">Lawley Village</p>
              <p className="font-display text-lg font-extrabold">Line Dance Club</p>
            </div>
          </div>
        </div>
        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-widest text-[#E06D44]">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/classes" className="text-[#F7F3EE] hover:text-[#E06D44]">Classes</Link></li>
            <li><Link to="/events" className="text-[#F7F3EE] hover:text-[#E06D44]">Events</Link></li>
            <li><Link to="/new-dancers" className="text-[#F7F3EE] hover:text-[#E06D44]">New to line dancing?</Link></li>
            <li><Link to="/basic-steps" className="text-[#F7F3EE] hover:text-[#E06D44]">Basic Steps</Link></li>
            <li><Link to="/dance-floor-etiquette" className="text-[#F7F3EE] hover:text-[#E06D44]">Dance Floor Etiquette</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-widest text-[#E06D44]">Get in touch</h4>
          <ul className="mt-4 space-y-3 text-sm text-[#D4C8BC]">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0" /> Telford &amp; Shropshire, UK</li>
            <li className="flex items-center gap-2"><Mail size={16} /> <a href="mailto:contactus@lawleylinedancers.uk" data-testid="footer-email" className="hover:text-[#E06D44] hover:underline">contactus@lawleylinedancers.uk</a></li>
            <li className="flex items-center gap-2"><Facebook size={16} /> <a href="https://www.facebook.com/people/Lawley-Village-Line-Dance-Club/100089800646679/" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="hover:text-[#E06D44] hover:underline">Find us on Facebook</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#D4C8BC]">
        <p className="flex flex-wrap items-center justify-center gap-2" data-testid="ldc-accreditation">
          <img src="/ldc-logo.png" alt="Line Dance Central" className="h-8 w-auto" />
          Proud to be a{" "}
          <a href="https://www.linedancecentral.uk" target="_blank" rel="noopener noreferrer" className="font-semibold underline hover:text-[#E06D44]">Line Dance Central</a>{" "}
          Accredited Club
        </p>
        <p className="mt-3">
          © {new Date().getFullYear()} Lawley Village Line Dance Club ·{" "}
          <Link to="/privacy" className="underline hover:text-[#E06D44]">Privacy</Link>
        </p>
      </div>
    </footer>
  );
}
